import React, { Component, Fragment } from 'react';
import { Grid, Table, TableHead, TableRow, TableCell, TableBody, Button, Box } from '@material-ui/core';
import InputText, { InputSelect } from '../../../../commonModules/interface/form-input-inline';
import { TableLayout } from '../../Stock/containers/Layout';

class NewKWH extends Component {
    render() {
        const { periodTab, dayTab } = this.props  
        return (
            <Fragment>
                {/* planning */}
                <Grid item xs={12}>
                    <TableLayout >
                        {/* <TableHead>
                            <TableRow>
                                <TableCell>Période</TableCell>
                                <TableCell className="text-center">Heure Debut</TableCell>
                                <TableCell className="text-center">Heure Fin</TableCell>
                            </TableRow>
                        </TableHead> */}
                        <TableBody>
                            {periodTab.map(period => (
                                <TableRow className={period.class} key={period.name}>
                                    <TableCell>{period.title}</TableCell>
                                    <TableCell> 
                                        <InputText 
                                            type="text" 
                                            onChange={this.props.handleChangeKwh} 
                                            name={`${period.name}_start`} 
                                            label="Heure Début"
                                            value={this.props.Kwh[period.name].start} 
                                        /> 
                                    </TableCell>
                                    <TableCell> 
                                        <InputText 
                                            type="text" 
                                            onChange={this.props.handleChangeKwh} 
                                            name={`${period.name}_end`} 
                                            label="Heure Fin"
                                            value={this.props.Kwh[period.nameStart].start} 
                                            disabled
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </TableLayout>
                    <TableLayout>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={3}>
                                    Prix du Kwh
                                </TableCell>
                            </TableRow>
                            {/* <TableRow>
                                <TableCell></TableCell>
                                <TableCell className="text-center table-kwh1">Prix Jour</TableCell>
                                <TableCell className="text-center table-kwh2">Prix Soir</TableCell>
                                <TableCell className="text-center table-kwh3">Prix Nuit</TableCell>
                            </TableRow> */}
                        </TableHead>
                        <TableBody>
                            {dayTab.map( day => (
                                <TableRow key={day.name}>
                                    <TableCell>{day.title}</TableCell>
                                    <TableCell className="table-kwh1">
                                        <InputText label="Jour" type="number" onChange={this.props.handleChangeKwh} name={`${day.name}_day`} value={this.props.Kwh[day.name].day }/> 
                                    </TableCell>
                                    <TableCell className="table-kwh2">
                                        <InputText label="Soir" type="number" onChange={this.props.handleChangeKwh} name={`${day.name}_evening`} value={this.props.Kwh[day.name].evening }/>
                                    </TableCell>
                                    <TableCell className="table-kwh3">
                                        <InputText label="Nuit" type="number" onChange={this.props.handleChangeKwh} name={`${day.name}_night`} value={this.props.Kwh[day.name].night }/>
                                    </TableCell>
                                </TableRow>

                            ))
                            }
                                                                
                        </TableBody>
                    </TableLayout>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputSelect 
                        value={this.props.Kwh.abo} 
                        onChange={(option) => this.props.handleChangeKwh(
                            {target: {name:"abo", value:option.value}}
                        )} 
                        name="abo"
                        label="Abonnement"
                        options={[
                            {value: "", label:"Non"},
                            {value: "month", label:"Mensuel"},
                            {value: "year", label:"Annuel"},
                        ]}
                    />
                    {/* <div className="form-group">
                    <label>Abonnement</label>
                        <div className="fg-line">
                            <option value="">Non</option>
                            <option value="month">Mensuel</option>
                            <option value="year">Annuel</option>
                        </select>
                        </div>
                    </div> */}
                </Grid>

                {this.props.Kwh.abo !== "" && 
                    <Grid item xs={12} sm={6}>
                        <InputText label="Prix de l'abonnement" type="text" value={this.props.Kwh.aboPrice} name="aboPrice" onChange={this.props.handleChangeKwh} />
                    </Grid>

                }

                <Grid item xs={12} sm={6}>
                    <InputSelect 
                        value={this.props.Kwh.paymentType} 
                        onChange={(option) => this.props.handleChangeKwh(
                            {target: {name:"paymentType", value:option.value}}
                        )} 
                        name="paymentType"
                        label="Type de Paiement"
                        options={[
                            {value: "prepaid", label:"Pré-payé"},
                            {value: "postpaid", label:"Post-payé"},
                        ]}
                    />
                    {/* <div className="form-group">
                    <label>Type de Paiement</label>
                        <div className="fg-line">
                        <select className="form-control" value={this.props.Kwh.paymentType} onChange={this.props.handleChangeKwh} name="paymentType">
                            <option key="prepaid" value="prepaid">Pré-payé</option>
                            <option key="postpaid" value="postpaid">Post-payé</option>
                        </select>
                        </div>
                    </div> */}
                </Grid>

                
                <Grid item xs={12} sm={6}>
                    <InputText label="Max Crédit" type="number" value={this.props.Kwh.maxCredit} name="maxCredit" onChange={this.props.handleChangeKwh} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputText label="Frais Installation" type="number" value={this.props.Kwh.installCost} name="installCost" onChange={this.props.handleChangeKwh} />
                </Grid>

            </Fragment>
        );
    }
}

export default NewKWH;